import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { MultiSelect } from "react-multi-select-component";
import SelectSearch, { fuzzySearch } from "react-select-search";
import Alert from './Alert';
import { getUserInfo } from './functions/userInfo';
import SessionFun from './functions/sessionFun';
import {environment} from './functions/environment';


function Asset_User_Mapping() {
    let [sessOut, setSessOut] = useState(false);
    let [branch, setBranch] = useState([]);
    let [sbranch, setSbranch] = useState("");
    let [account, setAccount] = useState([]);
    let [saccont, setSaccout] = useState("");
    const [selected, setSelected] = useState([]);
    let [user, setUsers] = useState([]);
    let [equipment, setEquipment] = useState([]);
    let [site, setSite] = useState([]);
    let [alert, setAlert] = useState({
        msg: "",
        status: false
    });
    let [selectedAssetId, setSelectedAssetId] = useState("");
    let [selectedSiteId, setSelectedSiteId] = useState("");
    let [apiSelectedUser, setApiSelectedUser] = useState([]);
    let [AssetData, setAssetData] = useState({
        branchName: "",
        accountID: "",
        siteID: "",
        assetID: "",
        userID: "",
    });

    useEffect(() => {
        getBranchList();
    }, [])
    let userObj = getUserInfo();

    function getBranchList() {
        fetch(environment.baseUrl + "getServiceBranch?", {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            }
        })
            .then((apiRes) => {
                apiRes.json().then((resp) => {
                    if (resp.code == 200) {
                        setBranch(resp.data.result);
                    }
                    else if (resp.code == 401) {
                        setSessOut(true);
                    }
                    else {
                        setBranch([]);
                    }
                })
            })
    }

    function getAccountbyBranch(e) {
        setSbranch(e)
        branch.forEach(element => {
            if (element.branchID == e)
                setAssetData({ ...AssetData, branchName: element.branchName })
        });
        setSelected([]);
        setApiSelectedUser([]);
        setAccount([]);
        setSite([]);
        setEquipment([]);
        setSelectedAssetId("");

        fetch(environment.baseUrl + "getAccountsByBranchID", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(
                {
                    "branchID": e
                })
        }).then((result) => {
            result.json().then(res => {
                if (res.code == 200) {
                    setAccount(res.data.result);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setAccount([]);
                }
            })
        })

    }

    function getSiteByAccount(e) {
        setSaccout(e)
        account.forEach(element => {
            if (element.accountID == e)
                setAssetData({ ...AssetData, accountName: element.accountName, accountID: e })
        });
        setSelected([]);
        setApiSelectedUser([]);
        setSite([]);
        setEquipment([]);
        setSelectedAssetId("");

        fetch(environment.baseUrl + "getSiteByAccID", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(
                {
                    "accountID": e
                })
        }).then((result) => {
            result.json().then(res => {
                if (res.code == 200) {
                    setSite(res.data.result);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setSite([]);
                }
            })
        })
    }

    function getBySites(e) {
        setAssetData({ ...AssetData, siteID: e.target.value })
        setEquipment([]);
        if (e.target.value) {
            setSelectedSiteId(e.target.value);
            getEquipmentBySite(e.target.value);
            getUserBySite(e.target.value);
            setSelected([])
        }
        else {
            setEquipment([]);
        }
    }

    function valueRenderer(selected) {
        let label = [];
        selected.map((item) =>
            label.push(item.label)
        )
        if (selected.length === 0) {
            return "Select"
        }
        else {
            return label.toString();
        }
    };

    function getEquipmentBySite(sid) {
        fetch(environment.baseUrl + "getEquipmentBySite?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(
                {
                    siteID: sid
                })
        }).then((result) => {
            result.json().then(res => {
                if (res.code == 200) {
                    setEquipment(res.data.result)
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setEquipment([]);
                }
            })
        })
    }
    function getUserBySite(sid) {
        fetch(environment.baseUrl + "getUserBySite?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(
                {
                    siteID: sid
                })
        }).then((result) => {
            result.json().then(res => {
                if (res.code === 200) {
                    setUsers(res.data.result);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setUsers([]);
                }
            })
        })
    }
    function getUsersByEquipment(e) {
        setAssetData({ ...AssetData, assetID: e.target.value })
        fetch(environment.baseUrl + "getUserByEquipment", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(
                {
                    assetID: e.target.value
                })
        }).then((result) => {
            result.json().then(res => {
                if (res.code === 200) {
                    let temp = [], selectedUserID = [];
                    res.data.result.forEach(element => {
                        temp.push(element.userID);
                        selectedUserID.push({ label: element.firstName+" "+element.lastName, value: element.userID });
                    });
                    setApiSelectedUser(temp);
                    setSelected(selectedUserID);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setApiSelectedUser([]);
                    setSelected([]);
                }
            })
        })
    } 

    function setAddRemoveItem() {
        let addUserID = []
        selected.map((item) =>
            addUserID.push(item.value)
        );
        let removeItem = apiSelectedUser.filter((o) => addUserID.indexOf(o) === -1);
        let addItem = addUserID.filter((o) => apiSelectedUser.indexOf(o) === -1);
        return (
            {
                removeUserID: removeItem,
                addUserID: addItem
            }
        )
    }

    function linkAssetWithSiteAndUser() {
        let obj = setAddRemoveItem();
        fetch(environment.baseUrl + "linkAssetWithSiteAndUser", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(
                {
                    assetID: AssetData.assetID,
                    siteID: AssetData.siteID,
                    removeUserID: obj.removeUserID,
                    addUserID: obj.addUserID
                })
        }).then((result) => {
            result.json().then(res => {
                setUsers([])
                setSelected([]);
                setApiSelectedUser([]);
                setSite([]);
                setEquipment([]);

                setSelectedAssetId("");
                setSbranch("");
                setErrorMsg({});
                setAccount([]);
                setSaccout("");
                setAlert({
                    msg: res.msg,
                    status: true
                })
                setAssetData({
                    branchName: "",
                    accountName: "",
                    accountID: "",
                    siteID: "",
                    assetID: "",
                    userID: "",
                })
            })
        })
    }


    let [errorMsg, setErrorMsg] = useState({});
    function validate() {

        let errror = {};
        if (AssetData.branchName == "") {
            errror.branchName = "This field is required";
        }
        if (AssetData.accountID == "") {
            errror.accountName = "This field is required";
        }
        if (AssetData.siteID == "") {
            errror.siteID = "This field is required";
        }

        if (AssetData.assetID == "") {
            errror.assetID = "This field is required";
        }
        setErrorMsg(errror);
        // console.log(AssetData, errror)
        if (Object.keys(errror).length == 0) {
            linkAssetWithSiteAndUser();
        }
    }


    return (
        <div className='main-container'>
            <SessionFun show={sessOut}></SessionFun>
            <Alert obj={alert} />
            <h4 className='main-heading'>Asset User Mapping</h4>
            <p className='short-link'><Link to='/'>Home&nbsp;
                <i className='fa fa-angle-right'></i></Link>&nbsp;Asset User Mapping</p>
            <div className="row card-box-block mt-3">
                <div className="col-sm-12">
                    <div className="row">
                        <div className="col-sm-4 left-col">
                            <Form.Group className="mb-3" >
                                <Form.Label>Branch<span style={{ color: "red" }}>*</span></Form.Label>
                                <SelectSearch
                                    options={branch.map(e => ({ name: e.branchName, value: e.branchID }))}
                                    value={sbranch}
                                    onChange={getAccountbyBranch}
                                    name="branch"
                                    placeholder="Select Branch"
                                    filterOptions={fuzzySearch}
                                    search
                                />
                                <div className="row" style={{ marginTop: 40 }}>
                                    <small className='red'>{errorMsg.branchName}</small>
                                </div>
                            </Form.Group>
                        </div>
                        <div className="col-sm-4">
                            <Form.Group className="mb-3" >
                                <Form.Label>Account<span style={{ color: "red" }}>*</span></Form.Label>
                                <SelectSearch
                                    options={account.map(e => ({ name: e.accountName, value: e.accountID }))}
                                    value={saccont}
                                    onChange={getSiteByAccount}
                                    name="account"
                                    placeholder="Select Account"
                                    filterOptions={fuzzySearch}
                                    search
                                />
                                <div className="row" style={{ marginTop: 40 }}>
                                    <small className='red'>{errorMsg.accountName}</small>
                                </div>
                            </Form.Group>
                        </div>
                        <div className="col-sm-4">
                            <Form.Group className="mb-3" >
                                <Form.Label>Site<span style={{ color: "red" }}>*</span></Form.Label>
                                <Form.Select className='textbox-back' aria-label="Default select example" onChange={getBySites}>
                                    <option value="">Select Site</option>
                                    {
                                        site.map((item, index) =>
                                            <option value={item.siteID} key={index} >{item.siteName}</option>
                                        )
                                    }
                                </Form.Select>
                                <small className='red'>{errorMsg.siteID}</small>
                            </Form.Group>
                        </div>
                        <div className="col-sm-4 left-col">
                            <Form.Group className="mb-3" >
                                <Form.Label>Equipment<span style={{ color: "red" }}>*</span></Form.Label>
                                <Form.Select className='textbox-back' aria-label="Default select example" name='assetID' onChange={getUsersByEquipment}>
                                    <option value="">Select Equipment</option>
                                    {
                                        equipment.map((item, index) =>
                                            <option value={item.assetID} key={index} >{item.assetID}</option>
                                        )
                                    }
                                </Form.Select>
                                <small className='red'>{errorMsg.assetID}</small>
                            </Form.Group>
                        </div>

                        <div className="col-sm-4 ">
                            <Form.Group className="mb-3" >
                                <Form.Label>Users</Form.Label>
                                <MultiSelect
                                    options={user.map(e => ({ label: e.firstName+" "+e.lastName, value: e.userID }))}
                                    value={selected}
                                    onChange={setSelected}
                                    labelledBy="Select user"
                                    valueRenderer={valueRenderer}
                                />

                                <small className='red'>{errorMsg.userID}</small>
                            </Form.Group>
                        </div>
                    </div>
                    <div className="row mt-3 justify-content-end" >
                        <div className="col-sm-6">
                            <Button className="add-btn btn-save float-end" onClick={validate}  >Submit</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Asset_User_Mapping
